<template>
  <div>
    <br /><br /><br />
    <br /><br /><br />
    <br /><br /><br />
    <br /><br /><br />
    <br /><br /><br />
    <v-container bg fill-height grid-list-md text-xs-center>
      <v-layout row wrap align-center>
        <v-flex>
          <!--<img width="300px;" src="../Images/logo_staging.png" />
          <br /><br /><br />
          <p style="font-size: 32px">Attempting to login...</p>
          <br /><br />
          <img width="100px" height="100px" src="../Images/portal.gif" />-->
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
};
</script>